export enum ETheme {
  light = 'light',
  dark = 'dark',
}

export interface ThemeColors {
  bg_primary: string;
  bg_root: string;
  primary_light: string;
  primary: string;
  primary_dark: string;
  light_gray_1: string;
  light_gray_2: string;
  gray_1: string;
  gray_2: string;
  gray_3: string;
  light_red_1: string;
  light_red_2: string;
  pink_1: string;
  red_1: string;
  black_1: string;
  light_blue_1: string;
  blue_1: string;
  button_hover: string;
  backdrop_hover: string;
  successful_1: string;
  successful_1_light: string;
  pending_1: string;
  processing_1: string;
  error_1: string;
  failed_1: string;
  chart_violet: string;
  chart_turquoise: string;
  chart_border_color: string;
  chart_line_color: string;
  chart_text_color: string;
  buy_trade_color: string;
  sell_trade_color: string;
}

/** @deprecated Use ThemeColors instead */
export type IColorsTheme = ThemeColors;
